export default __webpack_public_path__ + "b57c0b751be1329243648e49d42235cd.svg";